var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenderIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_11551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.05 8.537L18.585 5H14V3H22V11H20V6.414L16.463 9.951C17.6168 11.4635 18.1528 13.358 17.9623 15.2508C17.7719 17.1437 16.8692 18.8934 15.4372 20.1457C14.0051 21.398 12.1507 22.0594 10.2493 21.9958C8.34801 21.9322 6.5419 21.1485 5.1967 19.8033C3.85151 18.4581 3.06777 16.652 3.00419 14.7506C2.94061 12.8493 3.60194 10.9949 4.85426 9.5628C6.10658 8.13075 7.85631 7.2281 9.74914 7.03764C11.642 6.84719 13.5364 7.38315 15.049 8.537H15.05ZM10.5 20C11.9587 20 13.3576 19.4205 14.3891 18.3891C15.4205 17.3576 16 15.9587 16 14.5C16 13.0413 15.4205 11.6424 14.3891 10.6109C13.3576 9.57946 11.9587 9 10.5 9C9.04128 9 7.64233 9.57946 6.61088 10.6109C5.57943 11.6424 4.99997 13.0413 4.99997 14.5C4.99997 15.9587 5.57943 17.3576 6.61088 18.3891C7.64233 19.4205 9.04128 20 10.5 20V20Z",
    fill: "#09121F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_11551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenderIcon2);
export default __webpack_public_path__ + "static/media/genderIcon2.4e32361e4125fa82fbde8f469bf89245.svg";
export { ForwardRef as ReactComponent };